import { motion } from 'framer-motion';
import PulsatingCircles from './PulsatingCircles';
import Countdown from './Countdown';
import { useT } from '../i18n/LangProvider';

export default function Hero() {
  const { t } = useT();

  return (
    <section className="relative min-h-[140vh] sm:min-h-[145vh] w-full flex flex-col items-center justify-start overflow-hidden bg-bg-base">
      <div className="absolute inset-0 ambient-glow z-0" />
      <div className="absolute inset-0 z-[2]"><PulsatingCircles /></div>
      <div className="absolute inset-0 z-[1] pointer-events-none" style={{
        background: 'radial-gradient(ellipse 70% 60% at center, transparent 0%, rgba(21,41,52,0.25) 85%, rgba(21,41,52,0.45) 100%)'
      }} />

      <div className="max-w-7xl w-full mx-auto px-8 md:px-16 lg:px-20 relative z-20 grid grid-cols-12 gap-x-4 md:gap-x-8 pt-[26vh] sm:pt-[30vh]">
        <div className="col-span-12 md:col-span-10 md:col-start-2">
          <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }} className="flex items-center gap-3 mb-6">
            <span className="w-8 h-px bg-brand-red" />
            <p className="text-sm md:text-base tracking-[0.15em] text-ink/80 font-medium font-mono">{t('hero.date')}</p>
          </motion.div>

          <motion.p initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, delay: 0.1 }}
            className="font-display text-2xl md:text-3xl text-brand-red tracking-tight mb-2">
            {t('hero.title1')}
          </motion.p>

          <motion.h1 initial={{ opacity: 0, y: 15 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}
            className="font-display text-[13vw] sm:text-[9vw] md:text-[7vw] leading-[1.0] tracking-[-0.03em] text-ink">
            {t('hero.titleMain')}
          </motion.h1>

          <motion.p initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, delay: 0.2 }}
            className="mt-8 max-w-xl text-lg text-ink-muted">
            {t('hero.subtitle')} <span className="text-ink">{t('hero.subtitleBold')}</span>
          </motion.p>

          <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, delay: 0.35 }} className="mt-12">
            <Countdown />
          </motion.div>
        </div>
      </div>

    </section>
  );
}
